import { useMutation } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { PortingFormData } from "./interfaces/porting.interface";
import { gatewayPhone } from "../../../../gateways/gatewayPhone";



interface PhoneRequestPayload extends PortingFormData {
  externalUid: number;
}

interface PhoneRequestResponse {
  id: string;
  message: string;
  status: "success" | "error";
}

export const usePhoneRequestSendMutation = () => {
  // const token = sessionStorage.getItem("token");

  const mutation = useMutation<
    PhoneRequestResponse,
    AxiosError<{ message: string }>,
    PhoneRequestPayload
  >({
    mutationFn: async (payload: PhoneRequestPayload) => {
      const response = await gatewayPhone.post<PhoneRequestResponse>(
        "/porting",
        payload
      );
      return response.data;
    },
    onSuccess: (data) => {
      console.log("Phone request submitted successfully:", data);
    },
    onError: (error) => {
      console.error("Error submitting phone request:", error.response?.data);
    },
  });

  return {
    mutation,
    isLoading: mutation.isPending,
    isSuccess: mutation.isSuccess,
    isError: mutation.isError,
    error: mutation.error,
    data: mutation.data,
    sendRequest: mutation.mutate,
    sendRequestAsync: mutation.mutateAsync,
  };
};